module.exports = __webpack_public_path__ + "img/iconDown.20142d8e.svg";